import { Box, IconButton, LinearProgress, Typography } from '@mui/material';
import React from 'react';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import InfoComponent from './InfoComponent';
import InfoToggleButton from '../dashboard/menu/InfoToggleButton';

const CustomDialogTitle: React.FC<{ handleClose: () => void; title: string; loading: boolean; dontShowInfoButton?: boolean; notSticky?: boolean; }> = ({ handleClose, title, loading, dontShowInfoButton, notSticky }) => {

  return (
    <>
      <Box display="flex" alignItems="center" sx={{ padding: '10px', backgroundColor: 'primary.main', position: notSticky ? 'unset' : 'sticky', top: 0, zIndex: 1100 }} >
        <Box display="flex" alignItems="center">
          <InfoComponent infoContent={`Close "${title}"`} >
            <IconButton size="small" onClick={handleClose} disabled={loading}>
              <KeyboardArrowLeftIcon />
            </IconButton>
          </InfoComponent>
          <Typography component="h1" variant="h6">
            {title}
          </Typography>
        </Box>
        <Box flexGrow={1} />
        {!dontShowInfoButton &&
          <InfoToggleButton />
        }
      </Box>
      {loading && <LinearProgress color="primary" />}
    </>
  );
};

export default CustomDialogTitle;
